import bugsnag from '@bugsnag/browser';

import {
	getScreenDimensions,
	getScreenOrientation,
	isTouchScreen,
	getLocalState,
	isLocalhost,
} from 'commons/commons';

const MANUAL_BUGSNAG_REPORT_REGEX = /(^\[\S+] )/;

const preventReportingOnDev = (report) => {
	//const hostname = window.location.hostname;

	// manual bugsnag reports should be logged regardless of environment
	if (MANUAL_BUGSNAG_REPORT_REGEX.test(report.errorMessage)) {
		return;
	}

	if (isLocalhost()) {
		report.ignore();
	}
};

export const getReleaseStage = (host = window.location.host) => {
	if (/noteable\.co[:\d]*$/i.test(host)) return 'PROD';

	if (/^test\.ntbl\.link[:\d]*$/i.test(host)) return 'TEST';

	if (/ci-test\.ntbl\.link[:\d]*$/i.test(host)) return 'CI';

	if (/\.ntbl\.link[:\d]*$/i.test(host)) return 'DEV';

	if (isLocalhost(host)) return 'LOCAL';

	return 'OTHER';
};

const bugsnagClient = bugsnag({
	apiKey: '6ac91926d24d2a97b6e4d54d1cba9119',
	appVersion: '3.0.1',
	releaseStage: getReleaseStage(),
	//autoBreadcrumbs: false,
	beforeSend: (report) => {
		preventReportingOnDev(report);

		//if (getReleaseStage() !== 'production') {
		const state = getLocalState();
		const metaData = {
			...report.metadata,
			error: report.metadata?.error?.message ?? report.metadata?.error,
		};
		report.metaData = {
			datetime: '2021-02-07 16:34',
			tags: '',
			build: '3928',
			version: '3.0.1',
			commit: '4e579c7',
			branch: 'HEAD',
			...metaData,
			localState: state ? state.json : null,
		};
		//}
	},
});

function updateDeviceInformation() {
	bugsnagClient.device = {
		...bugsnagClient.device,
		dimensions: getScreenDimensions(),
		orientation: getScreenOrientation(),
		hasTouch: isTouchScreen(),
	};
}
updateDeviceInformation();
window.addEventListener('resize', updateDeviceInformation);

function updateUserInformation() {
	try {
		const userData = JSON.parse(localStorage.getItem('mem'));
		bugsnagClient.user = {
			state: 'logged-in',
			id: userData.userRef,
		};
	} catch (ex) {
		bugsnagClient.user = {
			state: 'logged-out',
			id: null,
		};
	}
}
updateUserInformation();
window.addEventListener('storage', updateUserInformation);

bugsnagClient.metadata = {
	deployment: {
		branch: 'HEAD',
		commit: '4e579c7',
	},
};

export default bugsnagClient;
